import { Box, Input } from '@apia/theme';
import { observer } from 'mobx-react-lite';
import { TFilterRenderer } from './types';
import {
  Autocomplete,
  AutocompleteController,
  AutocompleteOption,
  IconButton,
} from '@apia/components';
import { arrayOrArray, getLabel, TApiaFilter, useMount } from '@apia/util';
import ApiaApi, { makeApiaUrl } from '../../../apiaApi';
import { useMemo } from 'react';
import { useResponsiveTableContext } from '@apia/table';
async function getOptions(search?: string): Promise<AutocompleteOption[]> {
  if (!search) return [];
  const res = await ApiaApi.get<{
    row: { content: string; searchId: string }[];
  }>(
    makeApiaUrl({
      ajaxUrl: 'AutoCompleteAction.run',
      action: 'search',
      object: 'doc_free_metadata',
      filter: 'doc_free_metadata_title',
      id: 'doc_free_metadata_title',
      show: 'doc_free_metadata_title',
      likeSearch: true,
      allowLive: false,
      includeEnvId: true,
      distinctId: true,
      value: search,
    }),
  );
  const rows = arrayOrArray(res?.data?.row);
  return rows.map(({ content, searchId }) => ({
    label: content,
    value: searchId,
  }));
}

export const FreeLabelFilterRenderer: TFilterRenderer = observer(
  ({ state }) => {
    const { onFilterChange } = useResponsiveTableContext();
    const controller = useMemo(
      () =>
        new AutocompleteController({
          value: '',
          icon: 'LetterAutocomplete',
          options: [],
          onSearch: async (search, _acController) => {
            state.value = '';
            return getOptions(search);
          },

          onChange(str) {
            state.value = str;
          },
        }),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [],
    );
    useMount(() => {
      controller.state.options = [];
    });
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 2,
          width: '100%',
          alignItems: 'end',
          '.autocomplete__downArrow': {
            height: '46px!important',
            width: '23px!important',
            svg: {
              height: '100%',
              width: '100%',
            },
          },
        }}
      >
        <Box sx={{ width: '50%' }}>
          {getLabel('lblTit').text}
          <Autocomplete handler={controller} />
        </Box>
        <Box sx={{ width: '50%' }}>
          {getLabel('lblValue').text}
          <Input
            id={state.filterToId}
            data-query-filter-id={state.id}
            data-query-filter-part="filterToValue"
            disabled={state.readonly}
            value={state.filterToValue}
            onChange={(ev) => {
              state.filterToValue = ev.target.value;
              onFilterChange?.(state as any as TApiaFilter);
            }}
          />
        </Box>
        <Box sx={{ height: '50px', width: '50px' }}>
          {state?.removeFilter && (
            <IconButton
              sx={{ height: '50px', width: '50px' }}
              icon={'Trash'}
              onClick={() => {
                if (state?.removeFilter) {
                  controller.state.value = '';
                  controller.state.showValue = '';
                  state.removeFilter();
                }
              }}
            />
          )}
        </Box>
      </Box>
    );
  },
);
